import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    params: {
        page: 1,
        per_page: 30,
        q: {
            name: "",
            is_publish: "",
            is_recommend: ""
        }
    }
}
const mutations = {
    reviseLiveParams(state, val) {
       state.params = val
    }
}

export default {
    state,
    mutations
}